export { default as Img200 } from './processed/200/TOP-OF-THE-LAKE_S02.jpg';
export { default as Img400 } from './processed/400/TOP-OF-THE-LAKE_S02.jpg';
export { default as Imgthumb } from './processed/thumb/TOP-OF-THE-LAKE_S02.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/TOP-OF-THE-LAKE_S02.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/TOP-OF-THE-LAKE_S02.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      148,
      60,
      60
    ],
    "_population": 1,
    "_hsl": [
      0,
      0.42307692307692313,
      0.40784313725490196
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      108,
      29,
      14
    ],
    "_population": 2523,
    "_hsl": [
      0.02659574468085106,
      0.7704918032786886,
      0.2392156862745098
    ]
  },
  "Muted": {
    "_rgb": [
      164,
      88,
      88
    ],
    "_population": 2,
    "_hsl": [
      0,
      0.3015873015873016,
      0.49411764705882355
    ]
  },
  "LightMuted": {
    "_rgb": [
      209,
      201,
      184
    ],
    "_population": 1305,
    "_hsl": [
      0.11333333333333333,
      0.21367521367521364,
      0.7705882352941176
    ]
  },
  "DarkMuted": {
    "_rgb": [
      129,
      69,
      58
    ],
    "_population": 178,
    "_hsl": [
      0.025821596244131443,
      0.37967914438502676,
      0.36666666666666664
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/TOP-OF-THE-LAKE_S02.js